/**
 * Контракты системных настроек админки.
 * Лимит проходов гостя (E07.9) и отсрочка удаления клиентов (E11 / ФТ-6.5).
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";

export const guestPassLimitModeSchema = z.enum(["session", "model"]);
export type GuestPassLimitMode = z.infer<typeof guestPassLimitModeSchema>;

export const guestPassLimitSettingsSchema = z.object({
  mode: guestPassLimitModeSchema,
  limit: z.number().int().positive().max(1000),
});
export type GuestPassLimitSettings = z.infer<typeof guestPassLimitSettingsSchema>;

export const updateGuestPassLimitSettingsRequestSchema = guestPassLimitSettingsSchema;
export type UpdateGuestPassLimitSettingsRequest = z.infer<
  typeof updateGuestPassLimitSettingsRequestSchema
>;

export const guestPassLimitSettingsResponseSchema = apiSuccessSchema(guestPassLimitSettingsSchema);

/** Отсрочка удаления клиента в календарных днях (ФТ-6.5). */
export const clientDeleteDelaySettingsSchema = z.object({
  days: z.number().int().min(1).max(365),
});
export type ClientDeleteDelaySettings = z.infer<typeof clientDeleteDelaySettingsSchema>;

export const updateClientDeleteDelaySettingsRequestSchema = clientDeleteDelaySettingsSchema;
export type UpdateClientDeleteDelaySettingsRequest = z.infer<
  typeof updateClientDeleteDelaySettingsRequestSchema
>;

export const clientDeleteDelaySettingsResponseSchema = apiSuccessSchema(
  clientDeleteDelaySettingsSchema,
);

/** Дефолт совпадает с seed `client_delete_delay_days`. */
export const DEFAULT_CLIENT_DELETE_DELAY_DAYS = 7;
